import React, { useState } from 'react';
import Portfolio from './Portfolio';
import SiteSettings from './SiteSettings';
import ContactInfo from './ContactInfo';

const TABS = [
  { key: 'portfolio',     label: '🖼️  Portfolio' },
  { key: 'site-settings', label: '🎨  Site Settings' },
  { key: 'contact-info',  label: '📍  Contact Info' },
];

const WebsiteSettings = () => {
  const [activeTab, setActiveTab] = useState('portfolio');

  return (
    <div>
      {/* Tab bar */}
      <div style={{
        display: 'flex',
        gap: 4,
        borderBottom: '2px solid #e5e7eb',
        padding: '0 2rem',
        background: '#fff',
      }}>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '0.75rem 1.25rem',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: activeTab === tab.key ? 700 : 500,
              color: activeTab === tab.key ? '#630137' : '#6b7280',
              borderBottom: activeTab === tab.key ? '2px solid #630137' : '2px solid transparent',
              marginBottom: -2,
              transition: 'color 0.15s',
              whiteSpace: 'nowrap',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div>
        {activeTab === 'portfolio'     && <Portfolio />}
        {activeTab === 'site-settings' && <SiteSettings />}
        {activeTab === 'contact-info'  && <ContactInfo />}
      </div>
    </div>
  );
};

export default WebsiteSettings;
